export const GROUP_TYPE_SUPER_SLOTS = 'slotMachineGroup';
export const GROUP_TYPE_REDEEM_REWARDS = 'redeemRewardsGroup';
